// services/invoiceRequestService.ts
import api from './api';
import { InvoiceRequest, InvoiceRequestFormData, InvoiceRequestUpdateData, InvoiceRequestDeleteData } from '../types/invoiceRequest';
import { CompletedWorkWithoutInvoice } from '../types/invoiceRequest';

export const invoiceRequestService = {
  create: async (data: InvoiceRequestFormData) => {
    // 作成前に重複チェックを実行（工事IDのみ）
    const isDuplicate = await invoiceRequestService.checkDuplicate(data.constructionId);
    
    if (isDuplicate) {
        throw new Error('この工事に対して既に請求書作成依頼が登録されています');
    }
    
    const response = await api.post('/invoice-request/create', data);
    return response.data;
  },



  checkDuplicate: async (constructionId: number): Promise<boolean> => {
    try {
        const response = await api.get('/invoice-request/check-duplicate', {
            params: { constructionId }
        });
        return response.data.isDuplicate;
    } catch (error) {
        console.error('重複チェックに失敗しました:', error);
        throw error;
    }
  },

  getAll: async (params?: {
    billingMonth?: string;
    memberName?: string;
    isCompleted?: boolean;
    includeDeleted?: boolean;
  }): Promise<{ invoiceRequests: InvoiceRequest[]; total: number }> => {
    const response = await api.get('/invoice-request/list', { params });
    return response.data;
  },

  // 特定の請求書作成依頼を取得
  getById: async (id: number): Promise<InvoiceRequest> => {
    const response = await api.get(`/invoice-request/${id}`);
    return response.data.invoiceRequest;
  },

  // 工事の見積金額を取得
  getConstructionEstimatedAmount: async (constructionId: number): Promise<number> => {
    try {
      const response = await api.get(`/invoice-request/construction/${constructionId}/estimated-amount`);
      return response.data.estimatedAmount || 0;
    } catch (error) {
      console.error('見積金額の取得に失敗しました:', error);
      return 0;
    }
  },

  // 完了フラグの更新
  updateStatus: async (id: number, isCompleted: boolean, updatedByName?: string) => {
    const response = await api.put(`/invoice-request/${id}/status`, {
      isCompleted,
      updatedByName
    });
    return response.data;
  },

  // 請求書作成依頼の更新
  update: async (id: number, data: InvoiceRequestUpdateData) => {
    const response = await api.put(`/invoice-request/${id}`, data);
    return response.data;
  },

  // 請求書作成依頼の削除（論理削除）
  delete: async (id: number, data?: InvoiceRequestDeleteData) => {
    const response = await api.delete(`/invoice-request/${id}`, {
      data
    });
    return response.data;
  },

  // 全ての請求書依頼未作成の完了工事を取得（新規追加）
  getAllCompletedWorksWithoutInvoice: async (): Promise<{ success: boolean; data: CompletedWorkWithoutInvoice[] }> => {
    try {
      const response = await api.get('/invoice-request/all-completed-works-without-invoice');
      return response.data;
    } catch (error) {
      console.error('請求書依頼未作成の完了工事の取得に失敗しました:', error);
      throw error;
    }
  },

  // 請求書依頼を作成（既存のcreate関数と混同しないように別名で実装）
  createInvoiceRequestForConstruction: async (workId: string, userId: string) => {
    try {
      const response = await api.post(`/construction/${workId}/invoice-request`, { userId });
      return response.data;
    } catch (error) {
      console.error('請求書依頼の作成に失敗しました:', error);
      throw error;
    }
  }


};